import { render, staticRenderFns } from "./addLiveEvent.vue?vue&type=template&id=6208547a"
import script from "./addLiveEvent.vue?vue&type=script&lang=js"
export * from "./addLiveEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports